var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #3b5ca9;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.5,9c-2.69,0-5.18,1.45-6.5,3.79v-4.79h-2v8h8v-2h-4.38c1.38-2.7,4.69-3.77,7.4-2.38s3.77,4.69,2.38,7.4c-.94,1.84-2.83,2.99-4.9,2.99h-.5v2h.5c4.14,0,7.5-3.36,7.5-7.5s-3.36-7.5-7.5-7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,6H4v3.17l7.41,7.41.59.59v8.83h4v-2h2v2c0,1.1-.9,2-2,2h-4c-1.1,0-2-.9-2-2v-8l-7.41-7.41c-.38-.38-.59-.88-.59-1.41v-3.17c0-1.1.9-2,2-2h22v2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": " Transparent Rectangle ",
    className: "cls-1",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterResetIcon);
export default __webpack_public_path__ + "static/media/Filter_reset_icon.bf39703f7f82c9ca04124f688811a642.svg";
export { ForwardRef as ReactComponent };